import http from "@/utils/http";

// 分数、行为次数查询
export const driversBehaviors = (param) => http.get(`/api/drivers/behaviors/statistics/queries`, param);

// 折线图--日期查询
export const driversBehaviorsLineChart = (param) => http.get(`/api/drivers/behaviors/statistics`, param);

// 折线图--日期查询
export const driversBehaviorsEventsChart = (param) => http.get(`/api/drivers/behaviors/events/queries`, param);








// //发送验证码
// export const sendSmsCode = (param) =>
//   http.post("/api/messages/mobiles/codes/sends", param);
// // 验证码校验
// export const verifiesCode = (param) =>
//   http.post("/api/messages/mobiles/codes/verifies", param);
// // 登录
// export const login = (param) => http.post("/api/auth/signin", param);
// // 车辆列表
// export const carList = (param) => http.get("/api/vehicles/types", param);
// // 车辆详情信息
// export const carDetail = (param) => http.get("/api/vehicles/types/{id}", param);
// // 订单估算
// export const orderEstimate = (param) =>
//   http.post("/api/orders/estimates", param);
// // 订单新建
// export const newOrder = (param) => http.post("/api/orders", param);
// // 订单详情
// export const orderDetail = (id) => http.get(`/api/orders/${id}`);
// // 订单取消
// export const orderCance = (id, param) =>
//   http.put(`/api/orders/${id}/cancels`, param);

// // 订单列表
// export const orderList = (param) =>
//   http.get(
//     "/api/orders?size=" +
//       param.size +
//       "&year=" +
//       param.year +
//       "&month=" +
//       param.month
//   );

// // 支付
// export const pays = (id, param) => http.put(`/api/orders/${id}/pays`, param);

// // 评价
// export const reviews = (id, param) =>
//   http.put(`/api/orders/${id}/reviews`, param);

// // 用户信息
// export const userInfo = () => http.get(`/api/users/profiles`);

// // 国家列表
// export const countriesList = () => http.get(`/api/countries`);

// // 正在进行的订单
// export const orderProgress = () => http.get(`/api/orders/trips`);

// //订单更新
// export const orderUpdate = (id, param) => http.put(`/api/orders/${id}`, param);

// // 获取司机的位置
// export const getDriverLocation = (id) =>
//   http.get(`/api/orders/${id}/locations`);

// // 投诉
// export const putComplaints = (id, param) =>
//   http.put(`/api/orders/${id}/complaints`, param);

// // 评分
// export const evaluations = (id, param) =>
//   http.put(`/api/orders/${id}/evaluations`, param);

// // 评分列表
// export const getRatingsList = (rating) =>
//   http.get(`/api/ratings/tags?rating=${rating}`);

// //评价-查询
// export const getEvaluations = (id) => http.get(`/api/orders/${id}/evaluations`);

// //订单-查询订单支付状态
// export const orderPayState = (id) => http.get(`/api/orders/${id}/pays/states`);

// //订单-更新支付方式
// export const orderPayUpdate = (id, param) =>
//   http.put(`/api/orders/${id}/pays/methods`, param);

// // 订单-计算优惠

// export const orderDiscounts = (id, param) =>
//   http.put(`/api/orders/${id}/discounts`, param);

// //订单-订单收据  邮件
// export const ordersReceipts = (param) =>
//   http.post(`/api/orders/receipts`, param);
// //订单分享新建
// export const newShares = (param) => http.post("/api/orders/shares", param);

// //订单分享详情
// export const orderShares = (id) => http.get(`/api/orders/shares/views/${id}`);

// //订单支付
// export const payments = (param) => http.post("/api/payments", param);

// //订单地图-路线规划查询
// export const mapDirections = (id) => http.get(`/api/orders/${id}/directions`);
